import { apiClient } from '@/lib/api-client';
import type { CurrentUser } from '@/stores/auth.store';

export interface LoginInput {
  email: string;
  password: string;
}

export interface LoginResponse {
  accessToken: string;
  user: CurrentUser;
}

export async function loginRequest(input: LoginInput): Promise<LoginResponse> {
  const { data } = await apiClient.post<LoginResponse>('/auth/login', input);
  return data;
}

export interface RegisterInput {
  ruc: string;
  businessName: string;
  tradeName?: string;
  rubro: string;
  owner: { email: string; name: string; password: string };
}

export async function registerRequest(input: RegisterInput): Promise<LoginResponse> {
  const { data } = await apiClient.post<LoginResponse>('/auth/register', input);
  return data;
}

export async function logoutRequest(): Promise<void> {
  await apiClient.post('/auth/logout');
}

export async function meRequest(): Promise<CurrentUser | null> {
  const { data } = await apiClient.get<{ user: CurrentUser | null }>('/auth/me');
  return data.user;
}
